import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type PriceBadgeClasses =
  | 'pricesContainer'
  | 'divider'
  | 'price'
  | 'newPrice'
  | 'oldPriceContainer'
  | 'newPriceContainer'
  | 'textContainer'
  | 'text'
  | 'newPriceText'
  | 'indicativeNumber'
  | 'boldLabel'
  | 'newPriceTitleContainer'
  | 'oldPriceText'
  | 'container';

const priceBadgeStyles = makeStyles<ISpcTheme, PriceBadgeClasses>(
  ({ typography, palette, breakpoints }) => ({
    container: {
      width: '100%',
      maxWidth: '175px',
      position: 'relative',
      zIndex: 99,
      [breakpoints.down('sm')]: {
        maxWidth: '150px',
      },
    },
    pricesContainer: {
      borderTop: `1px solid ${palette.secondary.light}`,
      borderBottom: `1px solid ${palette.secondary.light}`,
      color: palette.secondary.light,
      textAlign: 'center',
    },
    divider: {
      borderRight: `1px solid ${palette.secondary.light}`,
      position: 'relative',
    },
    price: {
      fontSize: typography.fontMD,
      [breakpoints.down('sm')]: {
        lineHeight: '14px',
        fontSize: typography.fontSM,
      },
    },
    newPrice: {
      fontFamily: typography.fontFamily3,
    },
    oldPriceContainer: {
      paddingTop: '2px',
      position: 'relative',
    },
    newPriceContainer: {
      paddingTop: '2px',
    },
    textContainer: {
      color: palette.secondary.light,
      textAlign: 'center',
      [breakpoints.down('sm')]: {
        fontSize: typography.fontXXS,
      },
    },
    text: {
      lineHeight: 1,
      fontSize: typography.fontXS,
      [breakpoints.down('sm')]: {
        fontSize: typography.fontXXS,
      },
    },
    newPriceText: {
      fontWeight: typography.fontWeightBold,
    },
    oldPriceText: {},
    newPriceTitleContainer: {
      color: palette.text.secondary,
      display: 'flex',
      textAlign: 'center',
      cursor: 'pointer',
    },
    indicativeNumber: {
      color: palette.text.secondary,
      lineHeight: 1,
    },
    boldLabel: {
      fontWeight: typography.fontWeightBold,
    },
  }),
  { name: 'Customise_PriceBadge' },
);

export default priceBadgeStyles;
